import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { PathKey } from '../types/content';
interface PathBridgeProps {
  path: PathKey;
  onPathChange: (path: PathKey) => void;
}
export function PathBridge({
  path,
  onPathChange
}: PathBridgeProps) {
  const isDiscover = path === 'decouverte';
  return <section className="border-t border-line bg-white py-10" data-id="element-195" data-mp="1wprxbzyfdlq4">
      <div className="mx-auto flex max-w-shell flex-col items-start gap-4 px-5 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-196" data-mp="190h3z3jemtm0">
        <p className="ffp-display text-[19px] font-bold text-ink lg:text-[22px]" data-id="element-197" data-mp="1425r0jxtc2zk">
          {isDiscover ? 'Déjà licencié FFPLUM ?' : 'Vous accompagnez un futur pilote ?'}
        </p>
        <button type="button" onClick={() => onPathChange(isDiscover ? 'licencie' : 'decouverte')} className="ffp-focus group inline-flex items-center gap-2 rounded-full border border-navy px-5 py-2.5 text-[14px] font-semibold text-navy transition-colors duration-150 ease-soft hover:bg-navy hover:text-white" data-id="element-198" data-mp="1dz0t1ctaolil">
          {isDiscover ? 'Aller à mon espace et mes démarches' : 'Voir le parcours découverte'}
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-199" data-mp="1yyfx7w1b3n8w" />
        </button>
      </div>
    </section>;
}